import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NbAuthModule } from '@nebular/auth';
import {
  NbAlertModule,
  NbButtonModule,
  NbCheckboxModule,
  NbInputModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './login/login.component';
import { MfaComponent } from './mfa/mfa.component';
import { TimingPipe } from '../@theme/pipes';
import { ThemeModule } from '../@theme/theme.module';
import { MfaExpiredComponent } from './mfa_expired/mfa_expired.component';
import { MfaRejectedComponent } from './mfa_rejected/mfa_rejected.component';
import { MfaSuccessComponent } from './mfa_success/mfa_success.component';
import { MfaDoesNotExistComponent } from './mfa_does_not_exist/mfa_does_not_exist.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NbAlertModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    AuthenticationRoutingModule,
    NbSpinnerModule,
    NbAuthModule,
    ThemeModule,
  ],
  declarations: [
    LoginComponent,
    MfaComponent,
    MfaRejectedComponent,
    MfaExpiredComponent,
    MfaSuccessComponent,
    MfaDoesNotExistComponent,
  ],
})
export class AuthenticationModule {
}
